export { default as Awards } from './awards';
export { default as Education } from './education';
export { default as SEO } from './seo';
export { default as Skills } from './skills';
export { default as WorkExperience } from './work-experience';
